import React from 'react';
import { LucideIcon } from 'lucide-react';

interface StatisticsCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

export const StatisticsCard: React.FC<StatisticsCardProps> = ({
  title,
  value,
  icon: Icon,
  description,
  trend
}) => {
  return (
    <div className="bg-white/10 backdrop-blur-lg rounded-lg p-4">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-purple-200/70">{title}</p>
          <h4 className="text-2xl font-semibold text-purple-200 mt-1">{value}</h4>
        </div>
        <div className="p-2 bg-purple-500/20 rounded-lg">
          <Icon className="w-5 h-5 text-purple-300" />
        </div>
      </div>
      
      {(description || trend) && (
        <div className="mt-4 flex items-center justify-between">
          {description && (
            <p className="text-sm text-purple-200/70">{description}</p>
          )}
          {trend && (
            <span className={`text-sm flex items-center ${
              trend.isPositive ? 'text-green-400' : 'text-red-400'
            }`}>
              {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
            </span>
          )}
        </div>
      )}
    </div>
  );
};